import Warning from "../../../../src/components/Presentations/Warning";
import Success from "../../../../src/components/Presentations/Success";
import CodeBlock from "../../../../src/components/Presentations/CodeBlock";
import AnimatedBackground from "../../../../src/components/Presentations/AnimatedBackground";
import Confetti from "../../../../src/components/Presentations/Confetti";
import QandA from "../../../../src/components/Presentations/QandA";
import HTMLEditor from "../../../../src/components/HTMLEditor/HTMLEditorSimple";
import Poll from "../../../../src/components/Presentations/Poll";
import TitleSlide from "../../../../src/components/Presentations/Layout/TitleSlide";
import BaseSlide from "../../../../src/components/Presentations/Layout/BaseSlide";
import ListWithImage from "../../../../src/components/Presentations/Layout/ListWithImage";
import Infobox from "../../../../src/components/Presentations/Refactored/Infobox";
import * as React from 'react';
export default {
  Warning,
  Success,
  CodeBlock,
  AnimatedBackground,
  Confetti,
  QandA,
  HTMLEditor,
  Poll,
  TitleSlide,
  BaseSlide,
  ListWithImage,
  Infobox,
  React
};